import { Children as t, isValidElement as o, cloneElement as i } from "react";
function p({
  children: e,
  sharedProps: n
}) {
  return t.map(e, (r) => o(r) ? i(r, {
    ...r.props,
    ...n ?? {}
  }) : null);
}
export {
  p as sharePropsWithChildren
};
